export default __webpack_public_path__ + "static/media/exclamation.5e196bc0.svg";